import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const CreateExperimentInfoPage = lazy(
  () => import('~/features/experiments/pages/create-experiment-info-page'),
);

/** `/experiments/create/info` — Step 2: disclaimer + CTA to start the wizard. */
export const Route = createFileRoute('/_authenticated/_tenant/experiments_/create/info')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <CreateExperimentInfoPage />
    </Suspense>
  ),
});
